import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: idevo89
 * id C0E55306-EBD8-46D9-BF50-7285DC72D4B7
 * name delete-off
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/delete-off.svg
 * tags
 */
export const DeleteOffIcon = createSvgIcon(<><path d="M2 5.27L3.28 4L5 5.72L5.28 6L6.28 7L18 18.72L20 20.72L18.73 22L17.27 20.54C16.93 20.83 16.5 21 16 21H8C6.9 21 6 20.1 6 19V9.27L2 5.27M19 4V6H7.82L5.82 4H8.5L9.5 3H14.5L15.5 4H19M18 7V16.18L8.82 7H18Z" /></>, 'DeleteOffIcon');
export default DeleteOffIcon